import React from "react";
import { DatePicker, DateTimePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { TextField } from "@mui/material";
import "./datepicker-custom.css";

const DatePickerAuto = ({
  editTab = true,
  rest,
  value,
  label,
  onUpdate,
  variant,
  sx,
  includeTime = false,
  format = "YYYY-MM-DD",
  timeFormat = "HH:mm",
  fullWidth = true,
  required = false,
  disabled = false,
}) => {
  const PickerComponent = includeTime ? DateTimePicker : DatePicker;
  
  // Parse the value properly for both date and datetime
  const parseValue = (val) => {
    if (!val) return null;
    
    // If it's already a dayjs object, return it
    if (dayjs.isDayjs(val)) return val;
    
    // If it's a string, parse it
    if (typeof val === 'string') {
      // Try to parse as datetime first, then as date
      let parsed = dayjs(val);
      if (parsed.isValid()) return parsed;
      
      // If datetime parsing failed, try date parsing
      parsed = dayjs(val, format);
      if (parsed.isValid()) return parsed;
    }
    
    return null;
  };
  
  const handleChange = (event) => {
    if (!event) {
      onUpdate(null);
      return;
    }
    
    let formattedDate;
    if (includeTime) {
      formattedDate = dayjs(event?.["$d"]).format(`${format}THH:mm`);
    } else {
      formattedDate = dayjs(event?.["$d"]).format(format);
    }
    
    onUpdate(formattedDate);
  };

  return (
    <PickerComponent
      {...rest}
      disabled={disabled || !editTab}
      value={parseValue(value)}
      label={label}
      placeholder={includeTime ? `${format} ${timeFormat}` : format}
      onChange={handleChange}
      renderInput={(props) => (
        <TextField
          {...props}
          variant={`${editTab ? variant || "outlined" : "standard"}`}
          label={label}
          size="medium"
          fullWidth={fullWidth}
          required={required}
          ref={props.inputRef}
          onClick={
            props.InputProps?.endAdornment?.props?.children?.props?.onClick
          }
          sx={{
            "& button.MuiButtonBase-root.MuiIconButton-root.MuiIconButton-edgeEnd":
              {
                color: "#9A9A9A",
              },
            ...sx,
          }}
        />
      )}
    />
  );
};

export default DatePickerAuto;
